import { IterableChannelUpdate } from '@/types';

import { BffEndpoints } from './bff.constants';

export const fetchIterableSubscriptionsRequest = ({
  token,
}: {
  token?: string;
}) => ({
  url: BffEndpoints.ITERABLE_SUBSCRIPTION,
  method: 'GET',
  params: { token },
});

export const updateIterableSubscriptions = ({
  channels,
  token,
}: {
  channels: IterableChannelUpdate[];
  token?: string;
}) => ({
  url: BffEndpoints.ITERABLE_UPDATE_SUBSCRIPTION,
  method: 'POST',
  params: { token },
  body: {
    channels,
  },
});
